import React, {useEffect, useState} from "react";
import {useGlobal} from "../../Store";
import {Link} from "react-router-dom";
import styled from "styled-components";
import {postData} from "../../Utils/Server";
import Endpoints from "../../Constants/Endpoints";
import {useHistory} from "react-router-dom";
import {ERROR, Notify, SUCCESS} from "../../Utils/Notify";
import {updateDocumentTitle} from "../../Utils/Common";
import {ReasonCaptureModal} from "../Common/ReasonCaptureModal";
import PageLayout from "../Layout/PageLayout";
import {Button, Card, CardTitleBar, CardBody, FormField, TextInput, StatusBadge, Spinner} from "../UI";
import {tokens} from "../../theme/tokens";

const InfoTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    td {
        padding: ${tokens.spacing[3]} ${tokens.spacing[4]};
        font-size: ${tokens.typography.size.base};
        border-bottom: 1px solid ${tokens.colors.divider};
        vertical-align: middle;
    }
    td:first-child { color: ${tokens.colors.muted}; width: 45%; }
    td:last-child { color: ${tokens.colors.heading}; font-weight: ${tokens.typography.weight.semibold}; }
    tr:last-child td { border-bottom: 0; }
`;

const MeansTypeDetails = props => {
    let history = useHistory();
    const [globalState, globalActions] = useGlobal();
    const [isLoading, setIsLoading] = useState(false);
    const [item, setItem] = useState({title: ''});
    const [pendingAction, setPendingAction] = useState(null);
    const [pendingUpdate, setPendingUpdate] = useState(false);
    const [description, setDescription] = useState('');
    const [name, setName] = useState('');

    const {id} = props.match.params;

    const load = () => {
        let data = new FormData();
        data.append("id", id);

        setIsLoading(true);
        postData(Endpoints.MEANS_TYPE_FIND, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setItem(res.data);
                    setName(res.data.name);
                    setDescription(res.data.description);

                    updateDocumentTitle(res.data.name)
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    };

    useEffect(() => {
        load()
    }, []);

    function updateStatus(number, reason) {
        let data = new FormData();
        data.append("id", id);
        data.append("status", number);
        data.append("reason", reason);

        setIsLoading(true);
        postData(Endpoints.MEANS_TYPE_UPDATE_STATUS, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                Notify(res.message, res.success === 1 ? SUCCESS : ERROR);
                if (res.success === 1) {
                    load()
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    function updateDetails(e, reason) {
        if (e) e.preventDefault()

        let data = new FormData();
        data.append("id", id)
        data.append("name", name)
        data.append("description", description)
        data.append("reason", reason)

        setIsLoading(true)
        postData(Endpoints.MEANS_TYPE_UPDATE_DETAILS, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                Notify(res.message, res.success === 1 ? SUCCESS : ERROR);
                if (res.success === 1) {
                    load()
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    function deleteMeansType() {
        let data = new FormData();
        data.append("id", id);

        setIsLoading(true)
        postData(Endpoints.MEANS_TYPE_DELETE, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                Notify(res.success === 1 ? res.data : res.data, res.success === 1 ? SUCCESS : ERROR);
                if (res.success === 1) {
                    load()
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    return (
        <PageLayout
            title={item.name}
            actions={item.title !== '' ? (
                <div style={{display: "flex", alignItems: "center", gap: tokens.spacing[2]}}>
                    {isLoading && <Spinner size={18}/>}
                    {!isLoading &&
                    <Button
                        variant={item.status === 1 ? "danger" : "primary"}
                        onClick={e => setPendingAction(item.status === 1 ? 0 : 1)}>
                        {item.status === 1 ? "Deactivate" : "Activate"}
                    </Button>
                    }
                    <Link to={"/areas/" + item.area_id}>
                        <Button variant="outline">Back to area details</Button>
                    </Link>
                </div>
            ) : null}
        >
            {item.title !== '' &&
            <div className="row">
                <div className="col-md-6">
                    <Card padded>
                        <InfoTable>
                            <tbody>
                            <tr>
                                <td>Name</td>
                                <td>{item.name}</td>
                            </tr>
                            <tr>
                                <td>Description</td>
                                <td>{item.description}</td>
                            </tr>
                            <tr>
                                <td>Status</td>
                                <td>
                                    <StatusBadge tone={item.status === 0 ? "neutral" : "success"}>
                                        {item.status === 0 ? "INACTIVE" : "ACTIVE"}
                                    </StatusBadge>
                                </td>
                            </tr>
                            </tbody>
                        </InfoTable>
                    </Card>
                </div>
                <div className="col-md-6">
                    <Card padded={false}>
                        <CardTitleBar title="Update"/>
                        <CardBody>
                            <form onSubmit={e => { e.preventDefault(); setPendingUpdate(true); }}>

                                <FormField label="Name" required htmlFor="meansName">
                                    <TextInput id="meansName"
                                               type="text"
                                               required={true}
                                               placeholder="Name"
                                               value={name}
                                               onChange={e => setName(e.target.value)}
                                    />
                                </FormField>

                                <FormField label="Description" required htmlFor="meansDescription">
                                    <TextInput id="meansDescription"
                                               type="text"
                                               required={true}
                                               placeholder="Description"
                                               value={description}
                                               onChange={e => setDescription(e.target.value)}
                                    />
                                </FormField>

                                <Button type="submit" loading={isLoading}>Update</Button>

                            </form>
                        </CardBody>
                    </Card>
                </div>
            </div>
            }
            {pendingAction !== null &&
            <ReasonCaptureModal
                title={pendingAction === 0 ? "Deactivate means type" : "Activate means type"}
                onCancel={() => setPendingAction(null)}
                onConfirm={reason => { updateStatus(pendingAction, reason); setPendingAction(null); }}
            />
            }
            {pendingUpdate &&
            <ReasonCaptureModal
                title="Update means type details"
                onCancel={() => setPendingUpdate(false)}
                onConfirm={reason => { updateDetails(null, reason); setPendingUpdate(false); }}
            />
            }
        </PageLayout>
    )
};


export default MeansTypeDetails
